import ApiService from "../service/ApiService";

const apiService = new ApiService();

export const createSaleData = async (cart, clientAndAffiliate, coupon, totalPrice) => {
    
    const salesData = await Promise.all(
      cart.map(async (product) => {
        const [productId, planId] = product.id.split('_');
        const commissionData = await apiService.getCommissionData({ productId, couponId: coupon?.found?.id, planId, affiliateId: clientAndAffiliate?.affiliate_id? clientAndAffiliate?.affiliate_id : null});
    
        return {
          name: product.name,
          quantity: product.quantity,
          totalPrice: product.quantity * product.price,
          commissionData,
        };
      })
    );

    salesData.push(createCommission(coupon, clientAndAffiliate, totalPrice, salesData));

    return [{name: salesData[0].name, quantity: salesData[0].quantity, totalPrice: salesData[0].totalPrice}, salesData[1]];
};

export const createCommission = (coupon, clientAndAffiliate, totalPrice, salesData) => {
    let commission = 'R$ 0';

    if (!coupon?.found?.id) {
      return commission;
    }

    const commissionTotal = salesData.reduce((acc, curr) => {
        const { commissionData } = curr;
        if (!commissionData || !commissionData.commission_type) {
            return acc;
        }

        if (commissionData.commission_type === 'Percentual') {
            const itemCommission = (parseFloat(curr.totalPrice) * parseFloat(commissionData.commission)) / 100;
            return acc + itemCommission;
        } else if (commissionData.commission_type === 'Absoluto') {
            const itemCommission = parseFloat(commissionData.commission) * curr.quantity;
            return acc + itemCommission;
        }

        return acc;
    }, 0);

    commission = `R$ ${parseFloat(commissionTotal).toFixed(2)}`;

    return commission;
};

export const formatPaymentData = (paymentResponse: any, cardNumber: string) => {
  const rawPhone = paymentResponse.customer.phone // valor padrão, se necessário
  const area = rawPhone.slice(0, 2);
  const phoneNumber = rawPhone.slice(3);

  return {
    data: {
      customer: {
        name: `${paymentResponse.customer.first_name} ${paymentResponse.customer.last_name}`,
        email: paymentResponse.customer.email,
        phones: [
          { 
            country: "55",
            area: Number(area),
            number: Number(phoneNumber), 
            type: "MOBILE" 
          },
          { 
            country: "55", 
            area: Number(area),
            number: Number(phoneNumber), 
            type: "HOME" 
          },
          { 
            country: "55", 
            area: Number(area),
            number: Number(phoneNumber), 
            type: "BUSINESS" 
          }
        ]
      },
      paymentMethod: {
        type: "CREDIT_CARD",
        installments: paymentResponse.installments || 1,
        card: {
          number: cardNumber, // número sem espaços
          expMonth: paymentResponse.card.expiration_month,
          expYear: paymentResponse.card.expiration_year,
          holder: { 
            name: paymentResponse.card.holder_name 
          }
        }
      },
      amount: {
        value: paymentResponse.amount,
        currency: "BRL"
      },
      billingAddress: {
        street: paymentResponse.customer.address.street,
        number: paymentResponse.customer.address.number,
        complement: paymentResponse.customer.address.complement || "Sem complemento",
        regionCode: paymentResponse.customer.address.state,
        country: "BRA",
        city: paymentResponse.customer.address.city,
        postalCode: paymentResponse.customer.address.zip_code
      },
      shippingAddress: {
        street: paymentResponse.customer.address.street,
        number: paymentResponse.customer.address.number,
        complement: paymentResponse.customer.address.complement || "Sem complemento",
        regionCode: paymentResponse.customer.address.state,
        country: "BRA",
        city: paymentResponse.customer.address.city,
        postalCode: paymentResponse.customer.address.zip_code
      },
      dataOnly: false
    }
  };
};
